module.exports = __webpack_public_path__ + "static/media/statistics-hero-img-left.fc3152d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/statistics-hero-img-left.png
// module id = 701
// module chunks = 0